/* eslint-disable react/prop-types */
import React from 'react';
import ClockLoader from 'react-spinners/ClockLoader';
import './Spinner.css';

const Spinner = (props) => {
  let spinner = props.childern ? (
    <div className="Spinner">
      <ClockLoader
        color={"#FFFFFF"}
        loading={props.loading}
        size={100}
        className="clock-loader"
      />
    </div>
  ) : (
    <div className="Spinner">
      <div className="spinner-children">
        <ClockLoader
          color={"#FFFFFF"}
          loading={props.loading}
          size={100}
          className="clock-loader"
        />
        {props.children}
      </div>
    </div>
  );
  return <>{spinner}</>;
};
export default Spinner;
